/**
 * Returns true if a dock should be excluded from movement destination lists
 * based on its configuration status or paused state.
 *
 * Accepts either a raw configuration object (e.g. dock.configuration)
 * or a flattened dock door object with configurationStatus / paused fields.
 */
export function isDockUnavailableForMovement(
  dockOrConfig: { status?: string; paused?: boolean; configurationStatus?: string | null; configuration?: any } | null | undefined
): boolean {
  if (!dockOrConfig) return false;

  // Support flattened DockDoor shape (configurationStatus + paused at top level)
  const status = dockOrConfig.configurationStatus ?? dockOrConfig.configuration?.status ?? dockOrConfig.status;
  const paused = dockOrConfig.paused ?? dockOrConfig.configuration?.paused;

  if (status === 'unavailable') return true;
  if (paused === true) return true;
  return false;
}
